import { http } from '../../core/services/http';

export const getDispatchOpportunitiesCount = (userId: string | number | undefined, vendorId: number | undefined) =>
  http.get(`gus/counts/vendor/${vendorId}/user/${userId}`).then(response => response);

export const getDispatchOpportunitiesCountForToken = (token: string) =>
  http.get(`gus/counts/vendor/token/${token}`).then(response => response);
